import {
  Navbar,
  Hero,
  About,
  Support,
  AllInOne,
  Pricing,
  Footer,
} from "./components";
function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Support />
      <AllInOne />
      <Pricing />
      <Footer />
    </>
  );
}

export default App;
